"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiAcquireEmbedReportsSessionResponseToJSON = exports.StreemApiAcquireEmbedReportsSessionResponseFromJSONTyped = exports.StreemApiAcquireEmbedReportsSessionResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiAcquireEmbedReportsSessionResponseFromJSON(json) {
    return StreemApiAcquireEmbedReportsSessionResponseFromJSONTyped(json, false);
}
exports.StreemApiAcquireEmbedReportsSessionResponseFromJSON = StreemApiAcquireEmbedReportsSessionResponseFromJSON;
function StreemApiAcquireEmbedReportsSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiToken': !(0, runtime_1.exists)(json, 'api_token') ? undefined : json['api_token'],
        'apiTokenTtl': !(0, runtime_1.exists)(json, 'api_token_ttl') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['api_token_ttl']),
        'navigationToken': !(0, runtime_1.exists)(json, 'navigation_token') ? undefined : json['navigation_token'],
        'navigationTokenTtl': !(0, runtime_1.exists)(json, 'navigation_token_ttl') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['navigation_token_ttl']),
        'authenticationToken': !(0, runtime_1.exists)(json, 'authentication_token') ? undefined : json['authentication_token'],
        'authenticationTokenTtl': !(0, runtime_1.exists)(json, 'authentication_token_ttl') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['authentication_token_ttl']),
        'sessionReferenceTokenTtl': !(0, runtime_1.exists)(json, 'session_reference_token_ttl') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['session_reference_token_ttl']),
    };
}
exports.StreemApiAcquireEmbedReportsSessionResponseFromJSONTyped = StreemApiAcquireEmbedReportsSessionResponseFromJSONTyped;
function StreemApiAcquireEmbedReportsSessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'api_token': value.apiToken,
        'api_token_ttl': (0, _1.GoogleProtobufDurationToJSON)(value.apiTokenTtl),
        'navigation_token': value.navigationToken,
        'navigation_token_ttl': (0, _1.GoogleProtobufDurationToJSON)(value.navigationTokenTtl),
        'authentication_token': value.authenticationToken,
        'authentication_token_ttl': (0, _1.GoogleProtobufDurationToJSON)(value.authenticationTokenTtl),
        'session_reference_token_ttl': (0, _1.GoogleProtobufDurationToJSON)(value.sessionReferenceTokenTtl),
    };
}
exports.StreemApiAcquireEmbedReportsSessionResponseToJSON = StreemApiAcquireEmbedReportsSessionResponseToJSON;
//# sourceMappingURL=StreemApiAcquireEmbedReportsSessionResponse.js.map